import React from "react";

const Home = () => {
  return (
    <>
      <h1 className="mainhm">WELCOME To Techie Dishant </h1>
    </>
  );
};

export default Home;
